export const campaignEndpoints = {
  GET_CAMPAIGNS: '/campaigns/',
  GET_CAMPAIGN_DETAILS: '/campaigns/:campaignId/detailed/',
  GET_CAMPAIGN_LINKS: '/campaigns/:campaignId/links/',
  GET_CAMPAIGN_LINK: '/campaigns/:campaignId/links/:campaignLinkId/',
  CREATE_LINK: '/campaigns/:campaignId/links/',
  UPDATE_LINK: '/campaigns/:campaignId/links/:campaignLinkId/',
  DELETE_LINK: '/campaigns/:campaignId/links/:campaignLinkId/',
  GET_BRAND_STYLE: '/campaigns/styles/accounts/:entityId/',
  UPDATE_BRAND_STYLE: '/campaigns/styles/:brandStyleId/',
  CREATE_CAMPAIGN: '/campaigns/',
  UPDATE_CAMPAIGN: '/campaigns/:campaignId/',
  CHANGE_CAMPAIGN_STATUS: '/campaigns/:campaignId/actions/',
  GET_ANALYTICS: '/analysis/campaign/queries/:type/',
  GET_PRODUCT_RULE_ANALYTICS: '/campaigns/product-rule-analysis/',
  UPDATE_PRODUCT_RULES: '/campaigns/:campaignId/product-rule/',
  GET_RETAILER_BUCKETS: '/campaigns/:campaignId/:productId/buckets/',
  CREATE_RETAILER_BUCKET: '/campaigns/:campaignId/:productId/buckets/',
  UPDATE_RETAILER_BUCKET: '/campaigns/:campaignId/:productId/buckets/:bucketId/',
  DELETE_RETAILER_BUCKET: '/campaigns/:campaignId/:productId/buckets/:bucketId/',
  GET_RETAILERS_FOR_PRODUCT: '/campaigns/product-rule/accounts/',
  GET_CHAINS_FOR_PRODUCT: '/campaigns/product-rule/chains/',
  GET_LINK_SESSION_RECORDINGS: '/campaigns/links/:linkId/session-recordings/',
  SHARE_SESSION_RECORDING: '/campaigns/session-recordings/:recordingId/share/',
  UNSHARE_SESSION_RECORDING: '/campaigns/session-recordings/:recordingId/unshare/',
  GET_SCREENSHOTS: '/campaigns/:campaignId/screenshots/',
  GET_CAMPAIGN_PRODUCT_OVERRIDES: '/campaigns/:campaignId/:productId/overrides/',
  CREATE_CAMPAIGN_PRODUCT_OVERRIDE: '/campaigns/:campaignId/:productId/overrides/',
  UPDATE_CAMPAIGN_PRODUCT_OVERRIDE: '/campaigns/:campaignId/:productId/overrides/:overrideId/',
  DELETE_CAMPAIGN_PRODUCT_OVERRIDE: '/campaigns/:campaignId/:productId/overrides/:overrideId/',
  GET_CAMPAIGN_MODALITY_OVERRIDE: '/campaigns/:campaignId/modality-overrides/',
  CREATE_CAMPAIGN_MODALITY_OVERRIDE: '/campaigns/:campaignId/modality-overrides/',
  UPDATE_CAMPAIGN_MODALITY_OVERRIDE: '/campaigns/:campaignId/modality-overrides/update/',
  CREATE_ANALYTICS_EXPORT: '/analysis/campaign/exports/',
  GET_ANALYTICS_EXPORTS: '/analysis/campaign/exports/',
}
